function resolveFilter(type) {
    if (type == null) {
        return false;
    }

    if (type === 'date' || type === 'datetime') {
        return 'agDateColumnFilter';
    }
    if (type === 'number' || type === 'currency' || type === 'percent') {
        return 'agNumberColumnFilter';
    }
    if (type === 'boolean') {
        return 'agSetColumnFilter';
    }
    return 'agTextColumnFilter';
}

/**
 * Default properties for all columns.
 * Specific column definitions will override these.
 */
const defaultColDef = {
    sortable: true,
    hide: false,
    width: 150,
    pinned: null,
    keyCreator: null
};

/**
 * Creates a factory function for generating column definitions.
 * This pattern is great for injecting dependencies, like your filter resolver.
 *
 * @returns {Function} A function that takes a column config and returns a complete AG-Grid column definition.
 */
export const createColumnFactory = () => {
    return (config) => {
        const finalConfig = {
            ...defaultColDef,
            ...config
        };

        const { type } = finalConfig;

        if (type) {
            finalConfig.filter = resolveFilter(type);
        } else {
            finalConfig.filter = false;
        }

        return finalConfig;
    };
};
